<template>
  <element>
    <element>
        <ul class="aside-link">
            <router-link v-for="(item, idx) in menuData" active-class="on" :to="'/pages'+ item.link||''" :class="item.icon" tag="li" :key="idx">{{item.title}}</router-link>
        <!-- <router-link active-class="on" to="/pages/config" class="jcsz" tag="li"><a>基础设置</a></router-link>
        <router-link active-class="on" to="/pages/product" class="cpzx" tag="li"><a>产品中心</a></router-link>
        <router-link active-class="on" to="#" class="jgtx" tag="li"><a>价格体系</a></router-link>
        <router-link active-class="on" to="#" class="khjy" tag="li"><a>客户交易</a></router-link>
        <router-link active-class="on" to="#" class="gycg" tag="li"><a>供应采购</a></router-link>
        <router-link active-class="on" to="#" class="dzjs" tag="li"><a>对账结算</a></router-link>
        <router-link active-class="on" to="#" class="sjfx" tag="li"><a>数据分析</a></router-link> -->
        </ul>
    </element>
    <!-- <element>
        <ul class="aside-link topborder">
        <router-link to="#" active-class="on" class="fwgm" tag="li"><a>服务购买</a></router-link>
        <router-link to="#" active-class="on" class="fyzx" tag="li"><a>费用中心</a></router-link>
        </ul>
    </element> -->
  </element>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      value: {
        type: Array
      }
    },
    computed: {
      menuData: function () {
        return this.value
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/TopMenu.vue